// @ts-nocheck
import ActionTypes from "../constants/actions";
import { Map, Record, Set } from "immutable";
import { mergeArraytoSet, addToSet, updateSet, removeFromSet } from "../utils/redux";
import _ from "lodash";

const defaultState = new Map({});
export const Layout = Record({
  _id: "",
  name: "",
  pageLocation: "",
  html: "",
  tier: "",
  league: null,
  season: null,
  division: null,
  startDate: "",
  isConverted: false,
  active: false
});

export default (state = new Set(), action) => {
  switch (action.type) {
    case ActionTypes.FETCH_LAYOUTS_SUCCESS:
      return mergeArraytoSet(action.layouts, state, Layout);
    case ActionTypes.UPDATE_LAYOUT:
      if (action.layout._id) return updateSet(action.layout, state, Layout);
    case ActionTypes.ADD_LAYOUT:
      if (action.layout._id) return addToSet(action.layout, state, Layout);
      break;
    case ActionTypes.DELETE_LAYOUT:
      return removeFromSet(action.layout, state, Layout);
      break;
    default:
      return state;
  }
};
